import { render } from "./ProductGrid.vue?vue&type=template&id=23e37fdf&scoped=true"
import script from "./ProductGrid.vue?vue&type=script&lang=js"
export * from "./ProductGrid.vue?vue&type=script&lang=js"

import "./ProductGrid.vue?vue&type=style&index=0&id=23e37fdf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e37fdf"]])

export default __exports__